<div class="fuse-drawer-content">
  <ng-content></ng-content>
</div>
